export default {
    setRequestError(state, payload){
      state.request_error = payload.message;
    },
    setVisits(state, payload) {
      state.visits = payload;
    },
    setCurrentVisitId(state, payload){
      state.current_visit_id = payload.flvis_id;
    },
    setCurrentVisitPerson(state, payload){
      state.current_person.flvisp_id = payload.flvisp_id;
      state.current_person.flvisp_first_name = payload.flvisp_first_name;
      state.current_person.flvisp_last_name = payload.flvisp_last_name;
      state.current_person.flvisp_company = payload.flvisp_company;
      state.current_person.flvisp_email = payload.flvisp_email;
      state.current_person.flvisp_phone = payload.flvisp_phone;
      state.current_person.flvisp_website = payload.flvisp_website;
      state.current_person.flvisp_images = payload.flvisp_images;
    },
    setItemsOfSearch(state, payload){
      state.items_of_search = payload
    },
    setItemOfScan(state, payload){
      state.item_of_scan = payload
    },
    insertSelectedItem(state, payload){
      state.selected_items.unshift(payload)
    },
    insertVisitToStorage(state, payload){
      payload.items = [];
      state.stored_visits.push(payload);
    },
    insertItemOfVisitToStorage(state, payload, flvis_id){
      for(let i=0; i<state.stored_visits.length; i++){
        if(state.stored_visits[i].flvis_id == flvis_id){
          state.stored_visits[i].items.push(payload);
          break;
        }
      }
    },
    insertedItemId(state, payload){
      state.inserted_item_id = payload;
    },
    informSelectedItem(state, payload){
      for(let i=0; i<state.selected_items.length; i++){
        if(state.selected_items[i].flvisi_id == payload.flvisi_id){
          state.selected_items[i].tearsheet_checked = payload.tearsheet;
          state.selected_items[i].memo_checked = payload.memo;
          state.selected_items[i].quote_checked = payload.quote;
          state.selected_items[i].item_note = payload.note;
          break;
        }
      }
    },
    removeSelectedItem(state, payload){
      for(let i=0; i<state.selected_items.length; i++){
        if(state.selected_items[i].flvisi_id == payload.flvisi_id){
          state.selected_items.splice(i,1);
          break;
        }
      }    
    },
    emptySelectedItems(state){
      state.selected_items = [];
    },

    editVisitFlag(state){
      state.edit_visit_flag = 1;
    },

    deleteVisitFlag(state){
      state.edit_visit_flag = 0;
    }

  };